"use client";

import { BSRStarFilled } from "./bsr/BSRStarFilled";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { StarFilled as LegacyStarFilled } from "./legacy/StarFilled";

export const StarFilled = createBSRExperimentIcon(
  LegacyStarFilled,
  BSRStarFilled
);
